/**
 * Puts the scroll position of the page back to the top. The portal scrolls inside a content
 * panel rather than the window, so this walks up from `from` to every ancestor that can
 * scroll and resets it (instantly: a smooth scroll would still be moving during the transition).
 */
export function scrollToTop(from?: Element | null) {
    let node: Element | null = from ?? null;
    while (node) {
        if (node.scrollTop > 0) {
            node.scrollTop = 0;
        }
        node = node.parentElement;
    }
    window.scrollTo(0, 0);
}
